import * as React from "react";
import Drawer from "@mui/material/Drawer";
import { useState, useEffect, useRef } from "react";

import { Autocomplete } from "@mui/material";
import {
  FormControl,
  MenuItem,
  Select,
  InputLabel,
  TextField,
  CircularProgress,
  Box,
} from "@mui/material";
import { postPayment } from "../../../services/invoice";
import { updateinvoice } from "../../../services/invoice";

import { useDispatch, useSelector } from "react-redux";
import CloseIcon from "../../../assets/images/svgs/CloseIcon.svg";
import { getPartyList } from "../../../reducer/partyReducer";
import { updateAddPartyDropdownVisible } from "../../../reducer/expenseReducer";

import {
  updateDisplayCheckOutDrawer,
  updateShowMainBookingDetailsDrawer,
  updateBookingDetails,
  updateActiveTab,
  updatePaymentDetails,
  updateInvoiceDetails,
} from "../../../reducer/bookingReducer";
import { message } from "antd";

import AddParty from "../components/AddParty";

export default function CheckoutDrawer() {
  const { hotelDetails } = useSelector((store) => store.login);
  const { paymentModesResponse } = useSelector((store) => store.payments);

  const dispatch = useDispatch();
  const [partyName, setPartyName] = useState("");

  const {
    bookingDetails,
    paymentDetails,
    invoiceDetails,
    displayCheckOutDrawer,
    showMainBookingDetailsDrawer,
  } = useSelector((store) => store.booking);
  const { addPartyDropdownVisible } = useSelector((store) => store.expense);

  const [loading, setLoading] = useState(false);
  const [balanceDue, setBalanceDue] = useState("");
  const [type, setType] = useState("takePayment");

  const [amount, setAmount] = React.useState(Boolean);
  const [paymentMode, setPaymentMode] = React.useState("");
  const [paymentModePartyId, setPaymentModePartyId] = React.useState("");
  const [transactionNo, setTransactionNo] = React.useState(null);

  const { partyResponse } = useSelector((store) => store.party) || [];
  const [updatedPartyResponse, setUpdatedPartyResponse] = useState([]);

  const [methodToPartyId, setMethodToPartyId] = useState({});
  const [partyIdToMethod, setPartyIdToMethod] = useState({});

  const autoC = useRef(null);

  useEffect(() => {
    if (Array.isArray(paymentModesResponse) && paymentModesResponse?.length) {
      let updatedObj = {};
      let idToMethod = {};
      paymentModesResponse?.forEach((mode) => {
        const { method, partyId } = mode;
        updatedObj[method] = partyId;
        idToMethod[partyId] = method;
      });
      setMethodToPartyId(updatedObj);
      setPartyIdToMethod(idToMethod);
      if (
        !paymentMode &&
        paymentModesResponse &&
        paymentModesResponse.length > 0 &&
        paymentModesResponse[0].partyId
      ) {
        setPaymentMode(paymentModesResponse[0].partyId);
      }
    }
  }, [paymentModesResponse]);

  const addPayment = async () => {
    let roomInvoiceId = invoiceDetails
      ?.filter((Obj) => Obj?.invoiceType === "roomBill")
      ?.map((Obj) => Obj?.id)[0];

    setLoading(true);

    const payload = {
      amount: amount,
      bookingId: showMainBookingDetailsDrawer?.bookingId,
      hotelId: hotelDetails?.id,
      method: partyIdToMethod[paymentMode],
      transactionNo: transactionNo,
      invoiceId: roomInvoiceId,
      paymentModePartyId: paymentMode,
    };

    const data = await postPayment(payload);
    if (Boolean(data?.id)) {
      dispatch(updatePaymentDetails([...paymentDetails, data]));

      setPaymentMode("cash");
      setTransactionNo(null);
    } else {
      message.error("Something Went Wrong");
    }

    if (amount >= balanceDue) handleCheckOut();
    else {
      message.success("Payment Successful ", 1).then(() => {
        message.info(
          `Unable to Checkout. Please settle the remaining ${
            balanceDue - amount
          } Rs`,
          8,
        );
      });

      dispatch(updateDisplayCheckOutDrawer());
    }
    setLoading(false);
  };

  const handleCheckOut = async () => {
    const updatedData = JSON.parse(JSON.stringify(bookingDetails));

    updatedData.status = "completed";

    const data = await dispatch(updateBookingDetails(updatedData));

    if (Boolean(data.payload)) {
      dispatch(updateDisplayCheckOutDrawer());

      dispatch(
        updateShowMainBookingDetailsDrawer({
          visible: false,
          bookingId: "",
          bookingType: "",
        }),
      );

      message.success("Successfully Checked Out");

      dispatch(updateActiveTab("completed"));
    } else {
      dispatch(
        updateShowMainBookingDetailsDrawer({
          visible: false,
          bookingId: "",
          bookingType: "",
        }),
      );
      message.error("Something went wrong");
    }
    // setLoading(false);
  };

  useEffect(() => {
    updatePartyList();
  }, []);
  const updatePartyList = (searchText) => {
    if (!searchText || searchText === "" || searchText.trim() === "") {
      dispatch(
        getPartyList({
          hotelId: hotelDetails?.id,
        }),
      );
    } else {
      dispatch(
        getPartyList({
          hotelId: hotelDetails?.id,
          searchText,
        }),
      );
    }
  };
  useEffect(() => {
    if (Array.isArray(partyResponse)) {
      let newResponse = partyResponse?.map((Obj) => Obj?.displayName);
      setUpdatedPartyResponse(newResponse);
    }
  }, [partyResponse]);

  useEffect(() => {
    if (Array.isArray(invoiceDetails) && Array.isArray(paymentDetails)) {
      const localPayemnts = paymentDetails
        ?.map((item) => item.amount)
        ?.filter((Obj) => Boolean(Obj))
        ?.filter((Obj) => Obj > 0)
        ?.reduce((total, num) => total + num, 0);

      const localRefund = paymentDetails
        ?.map((item) => item.amount)
        ?.filter((Obj) => Boolean(Obj))
        ?.filter((Obj) => Obj < 0)
        ?.reduce((total, num) => total + -num, 0);

      let totalAmount = invoiceDetails
        ?.map((item) => item.total)
        ?.filter((Obj) => Boolean(Obj))
        ?.reduce((total, num) => total + num, 0);

      let balanceDue = totalAmount - localPayemnts + localRefund;

      if (balanceDue >= 0) {
        let updatedBalanceDue = balanceDue?.toFixed(0);
        setBalanceDue(updatedBalanceDue);
        setAmount(updatedBalanceDue);
      } else {
        setBalanceDue(0);
        setAmount(0);
      }
    }
  }, [paymentDetails, invoiceDetails]);

  const inputStyle = { height: "1rem" };

  const handleParty = async () => {
    setLoading(true);
    if (partyResponse && partyResponse?.length) {
      let roomInvoice = invoiceDetails?.filter(
        (Obj) => Obj?.invoiceType === "roomBill",
      )[0];

      let partyId = partyResponse?.filter(
        (Obj) => Obj?.displayName === partyName,
      )[0]?.id;

      let updatedInvoice = JSON.parse(JSON.stringify(roomInvoice));
      updatedInvoice.partyId = partyId;

      const payload = {
        id: updatedInvoice?.id,
        hotelId: hotelDetails?.id,
        body: updatedInvoice,
      };

      const paymentPayload = {
        amount: balanceDue,
        bookingId: bookingDetails?.id,
        hotelId: hotelDetails?.id,
        invoiceId: updatedInvoice?.id,
        method: "btc",
        paymentModePartyId: partyId,
      };

      const data = await updateinvoice(payload);

      if (Boolean(data?.id)) {
        const updatedData = invoiceDetails?.map((item) => {
          if (item.id === data.id) {
            return data;
          } else return item;
        });

        await postPayment(paymentPayload);

        await dispatch(updateInvoiceDetails(updatedData));
        message.success("Room Bill updated");

        handleCheckOut();
      }
    }
    setLoading(false);
  };

  const handleClose = () => {
    dispatch(updateAddPartyDropdownVisible(false));
    dispatch(updateDisplayCheckOutDrawer());
    setType("takePayment");
    setPaymentMode("cash");
    setPartyName("");
  };

  return (
    <Drawer
      PaperProps={{
        sx: {
          zIndex: 1,
          width: "60%",
          borderTopLeftRadius: "10px",
          borderTopRightRadius: "10px",

          "& .MuiDrawer-root": {
            position: "absolute",
            marginleft: "auto",
            right: 0,
          },
          "& .MuiPaper-root": {
            position: "absolute",
            marginLeft: "auto",
          },
        },
      }}
      sx={{
        "& .MuiDrawer-root": {
          position: "absolute",
          marginLeft: "auto",

          right: 0,
        },
        "& .MuiPaper-root": {
          position: "absolute",

          marginLeft: "auto",
        },
      }}
      anchor={"bottom"}
      open={displayCheckOutDrawer}
      onClose={handleClose}
    >
      <div className="flex flex-col mx-3 gap-5 items-start my-4   ">
        <div className="flex justify-between w-[100%]">
          <div className="flex w-[100%] gap-3 items-center ml-5 ">
            <h2 className="font-[400] text-[0.875rem] text-[#4D4D4D] font-nunito">
              Check Out:
            </h2>

            <div>
              <div className="flex items-center justify-center gap-[30px] ">
                <div className="flex items-center gap-[5px]">
                  <div
                    className={`h-[16px] w-[16px] rounded-full border-[1px] flex items-center justify-center ${
                      type === "takePayment"
                        ? "border-[#007FFF]"
                        : "border-[#808080]"
                    } cursor-pointer`}
                    onClick={() => setType("takePayment")}
                  >
                    {type === "takePayment" && (
                      <div className="w-[8px] h-[8px] rounded bg-[#007FFF]"></div>
                    )}
                  </div>
                  <span className="font-nunito font-[500px] text-[13px] leading-[17.73px] text-[#4D4D4D]">
                    Take Payment
                  </span>
                </div>
                <div className="flex items-center gap-[5px]">
                  <div
                    className={`h-[16px] w-[16px] rounded-full border-[1px] flex items-center justify-center ${
                      type === "attachToParty"
                        ? "border-[#007FFF]"
                        : "border-[#808080]"
                    } cursor-pointer`}
                    onClick={() => {
                      setType("attachToParty");
                      updatePartyList();
                    }}
                  >
                    {" "}
                    {type === "attachToParty" && (
                      <div className="w-[8px] h-[8px] rounded bg-[#007FFF]"></div>
                    )}
                  </div>
                  <span className="font-nunito font-[500px] text-[13px] leading-[17.73px] text-[#4D4D4D]">
                    Attach to Party
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div
            onClick={() => dispatch(updateDisplayCheckOutDrawer())}
            className="cursor-pointer"
          >
            <img src={CloseIcon} alt="" />
          </div>
        </div>

        {type === "takePayment" ? (
          <div className="flex flex-col mx-3 gap-3 items-center w-[100%]">
            <div className="flex  w-[100%] gap-7 justify-center">
              <TextField
                label="Amount"
                id="amount"
                size="small"
                type="text"
                onChange={(e) => setAmount(e.target.value)}
                value={Boolean(amount) ? amount : ""}
                autoComplete="true"
                sx={{
                  width: "45%",

                  "& label": {
                    color: "#0000004D",
                    fontFamily: "Poppins",
                    fontSize: "15px",
                  },
                  "& input": {
                    color: "#000000",
                    fontFamily: "Poppins",
                    fontSize: "15px",
                  },
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "8px",
                  },
                }}
              />

              <FormControl
                sx={{ width: "45%", color: "#0000004D" }}
                size="small"
              >
                <InputLabel
                  id="paymentMode"
                  sx={{ color: "#0000004D", fontSize: "15px" }}
                >
                  Payment Mode
                </InputLabel>

                <Select
                  labelId="SelectPaymentLabel"
                  id="selectPayment"
                  label="Payment Mode "
                  value={Boolean(paymentMode) ? paymentMode : ""}
                  onChange={(e) => {
                    setPaymentMode(e.target.value);
                    setPaymentModePartyId(e.target.value);
                    // setPaymentModePartyId()
                  }}
                  sx={{
                    borderRadius: "6px",
                    fontSize: "15px",
                    "& .MuiSelect-icon": {
                      color: "#2F80ED",
                    },
                  }}
                >
                  {paymentModesResponse?.map((mode) => {
                    const { method, partyId, paymentMode } = mode;
                    return (
                      <MenuItem
                        value={partyId}
                        sx={{
                          fontSize: "14px",
                          color: "#00000098",
                          fontFamily: "Poppins",
                          fontWeight: 400,
                        }}
                      >
                        {paymentMode}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </div>

            <TextField
              label="Transaction"
              id="transaction"
              size="small"
              onChange={(e) => setTransactionNo(e.target.value)}
              value={Boolean(transactionNo) ? transactionNo : ""}
              sx={{
                width: "94%",
                marginBottom: "1rem",
                marginTop: "1rem",

                "& label": {
                  color: "#0000004D",
                },
                "& input": {
                  color: "#000000",
                },
                "& .MuiOutlinedInput-root": {
                  borderRadius: "8px",
                },
              }}
            />
          </div>
        ) : (
          <div className="w-[100%] flex justify-center mb-5 relative">
            {addPartyDropdownVisible && (
              <AddParty setPartyName={setPartyName} partyType="source" />
            )}
            <Autocomplete
              id="party-name-select"
              sx={{
                width: "100%",
                "& label": {
                  color: "#0000004D",
                  fontFamily: "Poppins",
                  fontSize: "15px",
                },
                "& input": {
                  fontFamily: "Poppins",
                  fontSize: "0.75rem",
                  fontWeight: "400",
                  color: "#4D4D4D",
                },
                "& .MuiOutlinedInput-root": {
                  borderRadius: "8px",
                },
                "& .MuiInputLabel-root": {
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontFamily: "nunito",
                  color: "#808080",
                  fontSize: "0.75rem", // Font size when label is down
                },
                "& .MuiInputLabel-shrink": {
                  fontSize: "0.93rem", // Font size when label is up (focused)
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontFamily: "nunito",
                },
              }}
              options={
                Boolean(updatedPartyResponse)
                  ? [
                      "ADD PARTY",
                      ...Array.from(new Set(updatedPartyResponse || [])),
                    ]
                  : ["ADD PARTY"]
              }
              ref={autoC}
              value={partyName}
              onChange={(event, newValue) => {
                if (newValue === "ADD PARTY") {
                  dispatch(updateAddPartyDropdownVisible(true));
                  return;
                }
              }}
              inputValue={partyName}
              onInputChange={(event, newInputValue) => {
                if (newInputValue !== "ADD PARTY") {
                  updatePartyList(newInputValue);
                  setPartyName(newInputValue);
                }
              }}
              autoHighlight
              getOptionLabel={(option) => option}
              renderOption={(props, option) => (
                <Box
                  component="li"
                  {...props}
                  sx={{
                    color: option === "ADD PARTY" ? "#007FFF" : "#000000B2",
                    fontWeight: "400",
                    fontSize: "14px",
                    lineHeight: "18px",
                    fontStyle: "Poppins",
                  }}
                >
                  {option}
                </Box>
              )}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Party Name"
                  sx={{ borderRadius: 10 }}
                  inputProps={{
                    ...params.inputProps,
                    autoComplete: "new-password",
                  }}
                />
              )}
            />
          </div>
        )}
      </div>

      {type === "takePayment" ? (
        <button
          className="bg-[#007FFF] text-[#FFF] w-full h-[3rem]"
          onClick={() => addPayment()}
          disabled={loading}
        >
          {loading ? <CircularProgress size={16} /> : "Take Payment"}
        </button>
      ) : (
        <>
          {partyName ? (
            <button
              className="bg-[#007FFF] text-[#FFF] w-full h-[3rem]"
              onClick={() => handleParty()}
            >
              Save Changes
            </button>
          ) : (
            <button
              className="bg-[#EEEEEE] text-[#A0A0A0] w-full h-[3rem]"
              disabled={true}
            >
              Save Changes
            </button>
          )}
        </>
      )}
    </Drawer>
  );
}
